import React from 'react';
import { Box } from '@mui/material';
import LoadingSpinner from '../../ui/LoaderSpinner';
import {
  JobOpeningContentArea,
  JobOpeningSidebar,
  JobOpeningTabRenderer,
} from '../components';
import {
  useJobOpeningDetailsState,
  useJobOpeningSidebar,
} from '../hooks';
import { IJobOpeningDetails } from '../Interfaces/jobOpeningDetails.interface';

export const JobOpeningDetailsContainer = (props: IJobOpeningDetails) => {
  const {
    id,
    currentSubTab,
    navigateToSubTab,
    jobOpeningElements,
    jobTitleList,
    defaultEmployeeUserList,
    isLoading,
    editable,
    completedElement,
    hiringManagerOptions,
    setHiringManagerOptions,
    internalRecruiterOptions,
    setInternalRecruiterOptions,
  } = useJobOpeningDetailsState(props);

  const sidebarButtons = useJobOpeningSidebar(jobOpeningElements);

  if (isLoading) {
    return <LoadingSpinner />;
  }

  return (
    <Box
      sx={{
        p: { xs: 1.5, sm: 2 },
        display: 'flex',
        flexDirection: { xs: 'column', lg: 'row' },
        gap: { xs: 1.5, lg: 2 },
        minWidth: 0,
        width: '100%',
        boxSizing: 'border-box',
        alignItems: { xs: 'stretch', lg: 'flex-start' },
      }}
    >
      {/* Sidebar Navigation */}
      <JobOpeningSidebar
        buttons={sidebarButtons}
        currentTab={currentSubTab}
        onSelectTab={navigateToSubTab}
      />

      {/* Main Content Area */}
      <JobOpeningContentArea currentTab={currentSubTab}>
        <JobOpeningTabRenderer
          {...props}
          currentSubTab={currentSubTab}
          jobOpeningId={id}
          editable={editable}
          completedElement={completedElement}
          jobTitleList={jobTitleList}
          defaultEmployeeUserList={defaultEmployeeUserList}
          hiringManagerOptions={hiringManagerOptions}
          internalRecruiterOptions={internalRecruiterOptions}
          setHiringManagerOptions={setHiringManagerOptions}
          setInternalRecruiterOptions={setInternalRecruiterOptions}
        />
      </JobOpeningContentArea>
    </Box>
  );
};
